<div class="finding-details-content">
  <div class="finding-header-row d-flex align-items-center justify-content-between gap-2 margin-top-xs margin-bottom-lg">
    <h3 class="finding-secondary-heading" data-test-id="what-is-the-problem">
      {{ 'rule' | translate }}: {{ issue().data.actualResult }}
    </h3>
    <div class="d-flex align-items-center justify-content-end finding-metadata-actions">
      @if (hasDismissFindingRequiredSecurity$ | async) {
        @if (isDismissed()) {
          <button
            ds-button
            type="button"
            [variant]="DsButtonVariants.secondary"
            [icon]="Icons.ArrowRotateLeft"
            (click)="restoreFinding.emit()"
          >
            {{ 'label_restore_finding' | translate }}
          </button>
        } @else {
          <button
            ds-button
            type="button"
            [variant]="DsButtonVariants.secondary"
            [icon]="Icons.EyeSlash"
            (click)="dismissFinding.emit()"
          >
            {{ 'label_dismiss_finding' | translate }}
          </button>
        }
      }
      @if (issue().task) {
        <div class="linked-task" data-test-id="linked-task">
          <span class="fw-bold me-2">{{ 'linked_to_task' | translate }}:</span>
          <a
            #taskLinkElement
            id="task-id-link"
            data-test-id="linked-task-link"
            [routerLink]="taskLink"
            [attr.aria-label]="('linked_to_task' | translate) + ': ' + issue().task[$task.taskProjectId]"
          >
            {{ issue().task[$task.taskProjectId] }}
          </a>
        </div>
      } @else {
        <button
          ds-button
          type="button"
          data-test-id="btn-create-task"
          [variant]="DsButtonVariants.primary"
          [icon]="Icons.Pencil"
          (click)="createTask.emit()"
        >
          {{ 'label_create_task' | translate }}
        </button>
      }
    </div>
  </div>

  <div class="d-flex flex-column flex-lg-row finding-content-columns">
    <div class="flex-grow-1 min-width-0">
      <!-- default slot for consumer-supplied content, e.g. mobile's screenshot block -->
      <ng-content></ng-content>

      <div class="margin-bottom">
        <label class="label margin-bottom-xs">{{ 'label_where_is_it_located' | translate }}</label>
        <div class="where-it-is-located" data-test-id="where-it-is-located">
          {{ whereIsItLocated() }}
          @if (whereIsItLocatedUrl()) {
            <ds-link external="true" [href]="whereIsItLocatedUrl()">{{ whereIsItLocatedUrl() }}</ds-link>
          }
        </div>
      </div>

      @if (mainContentBlocks().length) {
        <div class="finding-content-divider" data-test-id="finding-content-divider"></div>
      }

      @for (block of mainContentBlocks(); track block.dataTestId; let last = $last) {
        <div class="margin-bottom" [attr.data-test-id]="block.dataTestId">
          @if (block.type === 'code') {
            <div class="margin-bottom-xs d-flex align-items-center justify-content-between">
              <label [attr.for]="block.copyElementId">{{ block.labelKey | translate }}</label>
              <ds-copy [htmlIdToCopy]="block.copyElementId"></ds-copy>
            </div>
            <pre
              class="finding-content-code-block"
            ><code [attr.id]="block.copyElementId" class="d-block p-2" [appHighlight]="block.value" [type]="block.codeLanguage"></code></pre>
          } @else {
            <label class="label margin-bottom-xs">{{ block.labelKey | translate }}</label>
            @if (block.type === 'html') {
              <div class="rule-description finding-content-rich-text pre-line" [innerHTML]="block.value | safeContent"></div>
            } @else if (block.type === 'highlighted') {
              <div
                class="rule-description finding-content-rich-text pre-line"
                [appHighlight]="block.value"
                [type]="block.codeLanguage"
              ></div>
            } @else {
              <div>{{ block.value }}</div>
            }
          }
        </div>
        @if (!last) {
          <div class="finding-content-divider" data-test-id="finding-content-divider"></div>
        }
      }

      <ng-content select="[finding-content-additional]"></ng-content>
      <div class="clearfix"></div>
    </div>

    <app-finding-metadata-card
      class="finding-metadata-card-column"
      [chipGroups]="metadataChipGroups()"
      [criteriaAndStandardLinks]="criteriaAndStandardLinks()"
      [issue]="issue()"
      [scanId]="scanId()"
    ></app-finding-metadata-card>
  </div>

  @if (hasHistory()) {
    <div class="finding-content-divider" data-test-id="finding-content-divider"></div>
    <div data-test-id="activity-log-section">
      <label class="label margin-bottom-xs">{{ 'label_activity_log' | translate }}</label>
      <div data-test-id="activity-log-list">
        @for (item of issueStatusHistories$ | async; track item) {
          <app-view-flaw-status-history-item [historyItem]="item" [expanded]="true"></app-view-flaw-status-history-item>
        }
      </div>
    </div>
  }
</div>
